export default class SacrificerModel
{
    constructor(sacrificer_info, beneficiary_info, passport_info, emergency_info, attachmnet){
        this.sacrificer_info = sacrificer_info
        this.beneficiary_info = beneficiary_info
        this.passport_info = passport_info
        this.emergency_info = emergency_info
        this.attachmnet = attachmnet
    }

    toFormData(){
        let fData = new FormData()
        
        //personal information for sacrificer.
        fData.append('name1', this.sacrificer_info.name1);
        fData.append('name2', this.sacrificer_info.name2);
        fData.append('name3', this.sacrificer_info.name3);
        fData.append('name4', this.sacrificer_info.name4);
        fData.append('family_name', this.sacrificer_info.family_name);
        fData.append('mother_name', this.sacrificer_info.mother_name);
        fData.append('date_wound', this.sacrificer_info.date_wound);
        fData.append('sacrificer_category_id', this.sacrificer_info.category_id);
        fData.append('dept', this.sacrificer_info.dept);
        fData.append('city_id', this.sacrificer_info.city_id);
        
        if(this.sacrificer_info.category_id == 2)
            fData.append('disability_ratio', this.sacrificer_info.disability_ratio);    
        
        //beneficiary info.
        if(this.sacrificer_info.category_id == 2){
            fData.append('relation_relative_id', 1);
        }else{
            fData.append('board_name', this.beneficiary_info.board_name);
            fData.append('relation_relative_id', this.beneficiary_info.relation_relative_id);
        }

        fData.append('doctrine_id', this.beneficiary_info.doctrine_id);
        fData.append('nationalism_id', this.beneficiary_info.nationalism_id);
        fData.append('transportation_type_id', this.beneficiary_info.transportation_type_id);
        fData.append('phone1', this.beneficiary_info.phone1);
        fData.append('phone2', this.beneficiary_info.phone2);
        fData.append('is_do_pilgrimaged', this.beneficiary_info.is_do_pilgrimaged);
        fData.append('is_benefited', this.beneficiary_info.is_benefited);

        fData.append('is_do_beneficiaries_pilgrimaged', this.beneficiary_info.has_prev_beneficiary);
        
        if(this.beneficiary_info.has_prev_beneficiary == 1){
            fData.append('beneficiary_name', this.beneficiary_info.prev_beneficiary_name);
            fData.append('pilgraimage_year', this.beneficiary_info.prev_beneficiary_year);
        }

        fData.append('nationalIdnumber', this.beneficiary_info.nationality_number);

        
        fData.append('address_city_id', this.beneficiary_info.city_id);
        fData.append('district', this.beneficiary_info.district);
        fData.append('region', this.beneficiary_info.region);
        fData.append('mahla', this.beneficiary_info.mahla);
        fData.append('zqaq', this.beneficiary_info.zqaq);
        fData.append('dar', this.beneficiary_info.dar);

        //passport info.
        fData.append('full_name', this.passport_info.full_name);
        fData.append('family_name_p', this.passport_info.family_name);
        fData.append('mother_name_p', this.passport_info.mother_name);
        fData.append('first_name_en', this.passport_info.first_name_en);
        fData.append('family_name_en', this.passport_info.family_name_en);
        fData.append('gender_id', this.passport_info.gender_id);
        fData.append('birth_date', this.passport_info.birth_date);
        fData.append('number', this.passport_info.number);
        fData.append('expire_date', this.passport_info.expire_date);
        fData.append('issure_date', this.passport_info.issue_date);

        //emergency info.
        fData.append('relation_relative', this.emergency_info.relation_relative);
        fData.append('beneficiary_full_name', this.emergency_info.beneficiary_full_name);
        fData.append('phone', this.emergency_info.phone);
        fData.append('is_have_disease', this.emergency_info.is_have_disease);
        fData.append('note', this.emergency_info.note);
           
        this.emergency_info.diseases.forEach((disease, index)=>{
            fData.append('diseases['+index+'][disease_id]', disease.id);
        })

        //attachment info.
        fData.append('attachment_passport', this.attachmnet.attachment_passport);
        fData.append('attachment_national', this.attachmnet.attachment_national);
        fData.append('attachment_address', this.attachmnet.attachment_address);
        
        if(this.sacrificer_info.category_id == 1)
            fData.append('attachment_qssam', this.attachmnet.attachment_qssam);
        
        if(this.sacrificer_info.category_id == 2)
            fData.append('attachment_wounded', this.attachmnet.attachment_wounded);
            

        if(typeof this.attachmnet.attachment_vaccine_card == 'object')
            fData.append('attachment_vaccine_card', this.attachmnet.attachment_vaccine_card);

        return fData
    }
}

